<template>
  <div class="md-layout">
    <md-card class="md-layout-item md-size-90 md-xsmall-size-80 mx-auto">
      <md-steppers :md-active-step.sync="active" index="3" md-linear md-dynamic-height>
        <md-step id="first" md-label="Datos generales" :md-editable="false" :md-done.sync="first">
          <first-step @success="firstEnd" :provider="provider"></first-step>
        </md-step>

        <md-step
          id="second"
          md-label="Cuentas bancarias"
          :md-editable="false"
          :md-done.sync="second"
        >
          <second-step @success="secondEnd" :provider="provider"></second-step>
        </md-step>

        <md-step id="third" md-label="Archivos" :md-editable="false" :md-done.sync="third">
          <third-step @success="thirdEnd" :provider="provider"></third-step>
        </md-step>
      </md-steppers>
    </md-card>
  </div>
</template>

<script>
import FirstStep from "./wizard/FirstStep";
import SecondStep from "./wizard/SecondStep";
import ThirdStep from "./wizard/ThirdStep";

export default {
  name: "WizardProvider",
  components: {
    FirstStep,
    SecondStep,
    ThirdStep,
  },
  data: () => ({
    active: "first",
    first: false,
    second: false,
    third: false,
    fourth: false,
    provider: {},
  }),
  methods: {
    firstEnd(prov) {
      this.provider = prov;
      this.setDone("first", "second");
    },
    secondEnd() {
      this.setDone("second", "third");
    },
    thirdEnd() {},
    setDone(id, index) {
      this[id] = true;

      if (index) {
        this.active = index;
      }
    },
  },
};
</script>

<style lang="css" scoped>
.md-card {
  overflow: visible;
}
</style>



// WEBPACK FOOTER //
// src/pages/Providers/WizardProvider.vue